import React, { useState, useEffect, useContext, useRef } from "react";
import "../css/CommonDesign.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Breadcrumbs, Container, Link, Stack } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { API } from "./constantsFront";
import dayjs from "dayjs";
import { MsgContext } from "../../App";
import parse from 'html-react-parser';
import MenuMenu from "./MenuMenu";

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

/**
 * 判定結果詳細
 * @returns 
 */
function D0122RacDetail() {
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState([<div className="d002_item"><p>該当するデータが存在しませんでした</p></div>]); // 基準値項目

  const [CPNDialogContent, setCPNDialogContent] = useState(""); //ダイアログコンテキスト

  // ダイアログ関連
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  const location = useLocation()
  let eachData;
  let jaData;
  if (location.state != null) {
    eachData = location.state.eachData;
    jaData = location.state.jaData;
  }

  // POSTデータ
  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    arrangement();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  async function arrangement() {
    try {
      if (eachData && jaData) {
        let itemCommonList = [];
        let countryProductNameList = [];
        let jaItemCommonList = [];
        let jaCountryProductNameList = [];
        body.countryName = eachData.country_name;
        body.productName = eachData.product_name;
        let res = await axios.post("/m_rac_item_common/select", body);
        itemCommonList = res.data.dataList;

        res = await axios.post("/m_rac_country_product_name/select", body);
        countryProductNameList = res.data.dataList;

        body.countryName = "日本";
        res = await axios.post("/m_rac_item_common/select", body);
        jaItemCommonList = res.data.dataList;

        res = await axios.post("/m_rac_country_product_name/select", body);
        jaCountryProductNameList = res.data.dataList;

        detailMethod(itemCommonList, countryProductNameList, jaItemCommonList, jaCountryProductNameList);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // 詳細画面
  function detailMethod(itemCommonList, countryProductNameList, jaItemCommonList, jaCountryProductNameList) {
    try {
      if (itemCommonList.length == 1 && countryProductNameList.length == 1) {
        let itemCommon = itemCommonList[0];
        let countryProductName = countryProductNameList[0];
        let detailContent = [];
        let tableData = [];
        let standardValue =
          <>
            <div class="value">
              {parse(eachData.standard_value).replace(/\n/g, '　')}<span>(mg/kg)</span>
            </div>
          </>
        let date;
        let remarksLink;
        if (itemCommon.acquisition_date) {
          date = dayjs(itemCommon.acquisition_date).format("YYYY/MM/DD");
        }

        if (countryProductNameList.length == 1) {
          const remarks = countryProductNameList[0].remarks;
          if (remarks != "―" && remarks != null) {
            setCPNDialogContent(<p>「{eachData.country_name}」向け「{eachData.product_name}」に使用する農薬全般に関する備考<br />{remarks}</p>);
            remarksLink =
              <div class="tag">
                <Link onClick={handleClickOpen}>
                  「{eachData.product_name}」に使用する農薬全般への備考
                </Link>
              </div>
          }
        }

        tableData.push(
          <>
            <dl>
              <dt>
                残留農薬<br class="forSP" />基準値
              </dt>
              <dd class="spflexnone">
                {standardValue}
                {remarksLink}
              </dd>
            </dl>

            {/* <dl>
              <dt>
                記号等の説明
              </dt>
              <dd class="spflexnone">
                ※１：検出限界値<br />
                ※２：暫定基準値
              </dd>
            </dl> */}

            <dl>
              <dt>
                検体
              </dt>
              <dd class="spflexnone">
                {countryProductName.specimen}
              </dd>
            </dl>

            <dl>
              <dt>
                各国資料等で検索する場合の品目名
              </dt>
              <dd class="spflexnone">
                {countryProductName.country_product_name}
              </dd>
            </dl>

            <dl>
              <dt>
                規定型式
              </dt>
              <dd class="spflexnone">
                {itemCommon.regulation_model}
              </dd>
            </dl>

            <dl>
              <dt>
                基準取得日
              </dt>
              <dd class="spflexnone">
                {date}
              </dd>
            </dl>

            <dl>
              <dt>
                関連法規等
              </dt>
              <dd class="spflexnone" style={{ whiteSpace: "pre-wrap" }}>
                {parse(itemCommon.related_laws)}
              </dd>
            </dl>

            <dl>
              <dt>
                各国・地域等のMRL確認用Webサイト等
              </dt>
              <dd class="spflexnone">
                <Link href={itemCommon.url} target="_blank">{parse(itemCommon.mrl)}</Link>
              </dd>
            </dl>

            <dl>
              <dt>
                基準値適用の優先順位
              </dt>
              <dd class="spflexnone">
                １.{itemCommon.priority1}<br />
                ２.{itemCommon.priority2}<br />
                ３.{itemCommon.priority3}
              </dd>
            </dl>

            <dl>
              <dt>
                参考リンク
              </dt>
              <dd class="spflexnone" style={{ display: "flex", flexWrap: "wrap" }}>
                <Link href="https://www.maff.go.jp/j/shokusan/export/zannou_kisei.html"
                  target="_blank">関連法規の入手方法、MRLデータベースの使用方法（一覧）</Link>
                <Link href="https://www.maff.go.jp/j/shokusan/export/zannou_kisei.html"
                  target="_blank">品目別、国・地域等別の残留農薬基準値表の見方及びFAQ</Link>
                <Link href="https://www.maff.go.jp/j/shokusan/export/zannou_kisei.html"
                  target="_blank">更新情報（前月比較）</Link>

              </dd>
            </dl>
          </>
        );

        let jaDetail = [];
        if (jaItemCommonList.length == 1 && jaCountryProductNameList.length == 1) {
          let jaItemCommon = jaItemCommonList[0];
          let jaCountryProductName = jaCountryProductNameList[0];
          let isRegist = <div>登録なし</div>
          let isApply = <div>適用なし</div>

          if(jaData.pesticides_name == "FLUAZIFOP-BUTYL"){
            isRegist = <div>{jaData.is_regist}</div>
            isApply = <div>{jaData.is_apply}</div>
          } else {
            if (jaData.is_regist == "○") {
              isRegist = <div>登録あり</div>
            }
            if (jaData.is_apply == "○") {
              isApply = <div>適用あり</div>
            }
          }

          let jaDate;
          if (jaItemCommon.acquisition_date) {
            jaDate = dayjs(jaItemCommon.acquisition_date).format("YYYY/MM/DD");
          }

          jaDetail.push(
            // <div>
            //   <div>日本の基準値</div>
            //   <div>{parse(jaData.standard_value)}(mg/kg)</div>
            //   <div>{isRegist}</div>
            //   <div>{isApply}</div>
            //   <Button href="http://db.ffcr.or.jp/" target="_blank">基準値確認</Button>
            //   <div>規定型式：{jaItemCommon.regulation_model}</div>
            //   <div>検体：{parse(jaCountryProductName.specimen)}</div>
            //   <div>備考：{parse(jaCountryProductName.remarks)}</div>
            //   <div>基準値取得日：{jaDate}</div>
            // </div>
            <dl>
              <dd class="spflexnone"
                style={{ display: "block", minWidth: "225px", width: "100%" }}>
                <div>日本の基準値</div>
                <div class="value">{parse(jaData.standard_value).replace(/\n/g, '　')}<span>(mg/kg)</span></div>
                <div class="tag" style={{ marginLeft: "0px" }}>
                  <span>{isRegist}</span>
                  <span>{isApply}</span>
                </div>
                {/* <Button href="http://db.ffcr.or.jp/"
                  style={{
                    borderRadius: "28px"
                    , color: "white"
                    , textDecoration: "none"
                    , marginTop: "10px"
                    , width: "100%"
                  }}
                  sx={{ backgroundColor: "#B00002" }}
                  target="_blank">基準値確認
                </Button> */}
                <div style={{ marginTop: "10px" }} class="checkDetailBtn"><a href="http://db.ffcr.or.jp/" target="_blank">基準値確認</a></div>

                <div>規定型式：{jaItemCommon.regulation_model}</div>
                <div>検体：{parse(jaCountryProductName.specimen)}</div>
                <div>備考：{parse(jaCountryProductName.remarks)}</div>
                <div>基準値取得日：{jaDate}</div>
              </dd>
            </dl>
          );
        }

        detailContent.push(
          <div>
            <div style={{ display: "flex" }}>
              {/* <p>「{eachData.country_name}」向け「{eachData.product_name}」に使用する「{eachData.pesticide}」の残留農薬基準値</p> */}
              <div style={{
                backgroundColor: "#F2F3F7"
                , width: "100%"
                , textAlign: "left"
                , color: "#22335C"
                , fontWeight: "700"
                , fontSize: "20px"
                , marginBottom: "10px"
              }}>
                「{eachData.country_name}」向け「{eachData.product_name}」に使用する「{eachData.pesticide}」の残留農薬基準値
              </div>

              {/* <Button onClick={conChange}>条件変更</Button> */}
            </div>
            <div >
              {/* <div className="d001_item"> */}
              <div >
                {/* <table bordercolor="darkgray"> */}
                <div class="checkResultWrap" >
                  <Stack spacing={3} direction={{ xs: 'column', lg: 'row' }}
                    style={{ width: "100%" }}>
                    <div style={{ minWidth: "70%", width: "100%" }}>
                      <div class="checkTable w100p">
                        {tableData}
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <Link style={{ display: "none" }} href="https://www.maff.go.jp/j/shokusan/export/attach/pdf/zannou_kisei-5.pdf" target="_blank">
                          更新情報（前月比較）
                        </Link>
                      </div>
                    </div>
                    <div style={{ marginLeft: "5px" }}/>
                    <div class="checkTable "
                      style={{ minWidth: "29%", height: "100%" }}>
                      {jaDetail}
                    </div>
                  </Stack>
                </div>
              </div>
            </div>

            <br />
            <div style={{ fontWeight: "700", color: "#22335C" }}>お問い合わせ先</div>
            <div class="checkTable w100p" style={{ padding: "15px" }}>
              <div style={{ fontWeight: "700" }}>
                農林水産省：輸出・国際局　規制対策グループ<br />
                <div style={{ display: "flex" }}>
                  <div style={{
                    backgroundColor: "#F2F3F7"
                    , width: "100px"
                    , textAlign: "center"
                    , color: "#22335C"
                  }}>担当者</div>
                  <div style={{ marginLeft: "10px" }}>農畜産物班</div>
                    
                    </div>
                    <hr style={{ margin: "10px 0 10px 0" }} />
                    <div style={{ display: "flex" }}>
                  <div style={{
                        backgroundColor: "#F2F3F7"
                        , color: "#1B335E"
                        , width: "100px"
                        , display: "flex"
                        , alignItems: "center"
                        , justifyContent: "center"
                      }}>
                        代表
                  </div>
                  <Stack spacing={0} direction={{ xs: 'column', md: 'row' }} style={{ marginLeft: "20px" }}>
                      <div>03-3502-8111</div>
                      <div>（内線4310）</div>
                    </Stack>
                    </div>
                    <hr style={{ margin: "10px 0 10px 0" }} />
                    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} >
                      <div style={{ display: "flex", minWidth: "50%" }} >
                        <div style={{
                          backgroundColor: "#F2F3F7"
                          , color: "#1B335E"
                          , width: "100px"
                          , textAlign: "center"
                        }}>
                          ダイヤルイン
                        </div>
                        <div style={{ marginLeft: "20px" }}>03-3501-4079</div>
                      </div>
                    </Stack>
              </div>
            </div>
          </div>
        );

        setDetailData(detailContent);
      } else {

      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  async function handleClickOpen() {
    setOpen(true);
  };

  // キャンセルボタン
  function cancelButton() {
    setOpen(false);
  };

  // 条件変更
  function conChange() {
    return navigate("/D0121RacTop", { state: { eachData: eachData } })
  }

  return (
    <>
      <MenuMenu sel={2} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="checkResultWrap">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Link underline="hover" key="2" color="inherit" href="./D0121RacTop" style={{ fontSize: "14px" }}>
                      残留農薬チェック
                    </Link>,
                    <Typography key="3" color="text.primary" style={{ fontSize: "14px" }}>
                      残留農薬チェック　詳細
                    </Typography>
                  </Breadcrumbs>
                  {/* <h1>残留農薬基準値詳細</h1> */}
                  {/* <div className="center"> */}
                  <div>

                  {/* 「植物検疫」、「動物検疫及び食品衛生」、「放射性物質」、「残留農薬」、「食品添加物」の５つの規制を基に判定結果を出しています。各規制の詳細は「規制の詳細を見る」ボタンをクリックするとご覧いただけます。 */}
                  「植物検疫」、「動物検疫」、「放射性物質」、「残留農薬」、「食品添加物」の５つの規制を基に判定結果を出しています。各規制の詳細は「規制の詳細を見る」ボタンをクリックするとご覧いただけます。

                  </div>

                  {detailData}
                  {/* </div> */}

                  {/* <div style={{ textAlign: "center" }}>
                    <Button className="search_button"
                      style={{ borderRadius: "28px" }}
                      onClick={conChange}>
                      戻る
                    </Button>
                  </div> */}
                  <div style={{ textAlign: "center" }}>
                    <input type="button" style={{ width: "150px", color: "#1B335E" }} value="戻る" class="buttonDefault graylBtn" onClick={conChange} />
                  </div>
                </Stack>
              </Container>

              <div className="dialog">
                <Dialog
                  fullWidth
                  maxWidth="md"
                  Height="md"
                  fullScreen={fullScreen}
                  open={open}
                  onClose={cancelButton}
                  aria-labelledby="responsive-dialog-title"
                >
                  <BootstrapDialogTitle id="customized-dialog-title" onClose={cancelButton}>
                    備考
                  </BootstrapDialogTitle>
                  <DialogContent id="dialog-content">
                    {CPNDialogContent}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={cancelButton}>
                      閉じる
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default D0122RacDetail;